module.exports = __webpack_public_path__ + "img/waitthai.6b0713c1.png";